var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBold(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 14,
    viewBox: "0 0 10 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.40014 6.65286C8.93493 6.06598 9.26281 5.27285 9.26281 4.40091V4.22988C9.26281 2.42564 7.86058 0.961792 6.13207 0.961792H1.42243C1.1821 0.961792 0.986328 1.16804 0.986328 1.42124V12.8084C0.986328 13.0817 1.19642 13.3031 1.45586 13.3031H6.52839C8.39059 13.3031 9.89946 11.7235 9.89946 9.77338V9.58893C9.89946 8.36487 9.30419 7.28669 8.40014 6.65286ZM2.51429 2.57152H6.09069C6.99951 2.57152 7.73484 3.31602 7.73484 4.23658V4.39588C7.73484 5.31477 6.99792 6.06095 6.09069 6.06095H2.51429V2.57152ZM8.34921 9.77171C8.34921 10.8264 7.52634 11.6816 6.51088 11.6816H2.51429V7.68074H6.51088C7.52634 7.68074 8.34921 8.5359 8.34921 9.59061V9.77171Z",
    fill: "black",
    fillOpacity: 0.85
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBold);
export default __webpack_public_path__ + "static/media/bold.2d1665aea94763f0b21d31c1a655dd3d.svg";
export { ForwardRef as ReactComponent };